import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItemDivider,
  IonItemGroup,
  IonRow,
} from '@ionic/angular/standalone';
import { DecaStopType } from '@okcargo-apps/shared-domain';
import { DecaEditStopComponent } from '../deca-edit-stop/deca-edit-stop.component';
import { DecaSegmentFormModel, IPreviousAddressData, IStopLocationData } from '../deca-forms.model';

@Component({
  selector: 'lib-deca-edit-segment',
  templateUrl: './deca-edit-segment.component.html',
  styleUrls: ['./deca-edit-segment.component.scss'],
  imports: [
    IonItemGroup,
    IonItemDivider,
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonButton,
    IonIcon,
    ReactiveFormsModule,
    DecaEditStopComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DecaEditSegmentComponent {
  public form = input.required<FormGroup<DecaSegmentFormModel>>();
  public index = input.required<number>();
  public totalSegments = input.required<number>();

  public initialOriginLocation = input<IStopLocationData | null>(null);
  public initialDestinationLocation = input<IStopLocationData | null>(null);

  public previousAddressData = input<IPreviousAddressData | null>(null);

  public readonly removeSegment = output<void>();
  public readonly locationChange = output<{ type: DecaStopType; location: IStopLocationData | null }>();
}
